import styled from 'styled-components';

export const Cell = styled.div`
  .text-858dbd {
    color: var(--color-text-muted);
  }
`;
